
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CityDirectory } from './CityDirectory';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <motion.footer 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="bg-gray-100 py-8 px-6 md:px-10 border-t border-gray-200 mt-20"
    >
      <CityDirectory />
      
      <div className="container mx-auto mt-10">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-lg font-semibold text-primary">{t('siteTitle')}</h3>
          </div>
          <div className="flex flex-col md:flex-row gap-4 items-center">
            <Link to="/kontakt" className="text-gray-500 hover:text-primary transition-colors">
              {t('contact')}
            </Link>
            <Link to="/impressum" className="text-gray-500 hover:text-primary transition-colors">
              Impressum
            </Link>
            <p className="text-gray-500 text-sm text-center md:text-right">
              {t('copyright')}
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};
